import { Coffee, ShieldCheck, CodeXml, Shield } from 'lucide-react';
import { useTeamTags } from '../../hooks/useTeamTags';
import { teamTagLabel } from '../../lib/teamTags';

const ICONS = { cafe_team: Coffee, moderator: ShieldCheck, developer: CodeXml, admin: Shield };

// The small pill beside a name for people with a team tag (048). Renders
// nothing for everyone else, so it can sit in every byline unconditionally.
// Pass `tag` directly where it is already known (the admin modal preview).
export default function TeamTag({ userId, tag: tagProp, className = '' }) {
  const tags = useTeamTags();
  const tag = tagProp ?? tags?.get(userId);
  const label = teamTagLabel(tag);
  if (!label) return null;
  const Icon = ICONS[tag] || Shield;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-1.5 py-px text-[11px] font-semibold leading-4 whitespace-nowrap flex-shrink-0 ${className}`}
      style={{
        backgroundColor: 'rgba(var(--brand-primary-rgb), 0.12)',
        color: 'var(--brand-primary)',
      }}
    >
      <Icon size={11} strokeWidth={2.5} aria-hidden="true" />
      {label}
    </span>
  );
}
